const TaskForm = React.memo(function TaskForm(props){
    const {
        value,
        formItems,
        formItemConditions,
        showLabelAsPlaceholder,
        onChange,
    } = props;

    let visibilityConditions = parseVisibilityConditions(value, formItems, formItemConditions);

    //useRenderDebug('TaskForm', {props});

    return (
        <div className={`processes-task-form flex-vertical`}>
            <TaskFormFieldset
                items={formItems}
                value={value}
                display={'flex-vertical'}
                visibilityConditions={visibilityConditions}
                showLabelAsPlaceholder={showLabelAsPlaceholder}
                onChange={onChange}
            />
        </div>
    );
});

TaskForm.propTypes = {
    value: PropTypes.any,
    formItems: PropTypes.any,
    formItemConditions: PropTypes.any,
    showLabelAsPlaceholder: PropTypes.bool,
    onChange: PropTypes.func,
};

TaskForm.defaultProps = {
    value: {},
    formItems: [],
    formItemConditions: [],
    showLabelAsPlaceholder: false,
    onChange: (path, value) => {},
};
TaskForm.displayName = 'TaskForm';